module.exports = __webpack_public_path__ + "static/media/capstone_permissions.cd826c2a.yaml";